import moment from 'moment';
import 'moment/locale/th';
import DroneLayer from './DroneLayer';

class Plan {

    constructor() {
        this.uid = ''

        // Raw data
        this.name = '';
        this.address = '';
        this.deed = '';
        this._description = '';
        this.createdAt = null;
        this.updatedAt = null;

        // Relational data
        this.userUid = '';
        this.userName = '';
        this.savedUid = null
        // Object data
        this.shapesArray = [];
        this.markerCoord = null;
        this.droneLayersArray = [];

        // Object setting
        this.layersSetting = [];

    }

    static initBySnapshot(docSnapshot) {
        const obj = docSnapshot.data();
        const plan = new Plan();

        // Raw data
        plan.uid = docSnapshot.id;
        plan.name = ( obj.name !== undefined ) ? obj.name : '';
        plan.name = ( plan.name !== '') ? plan.name : 'ไม่มีชื่อ'
        plan.address = ( obj.address !== undefined ) ? obj.address : '';
        plan.deed = ( obj.deed !== undefined ) ? obj.deed : '';
        plan._description = ( obj.description !== undefined ) ? obj.description : '';
        plan.createdAt = ( obj.created_date !== undefined && obj.created_date !== null ) ? obj.created_date.toDate() : null;
        plan.updatedAt = ( obj.updated_date !== undefined && obj.created_date !== null ) ? obj.updated_date.toDate() : null;
        plan.userUid = ( obj.uid !== undefined ) ? obj.uid : null
        plan.savedUid = ( obj.saved_uid !== undefined) ? obj.saved_uid : null
        // Object data
        plan.markerCoord = ( obj.midpoint !== undefined && obj.midpoint !== '' && obj.midpoint !== null) ? {lat: obj.midpoint._lat, lng: obj.midpoint._long} : null;
        if ( obj.layers !== undefined && obj.layers.length !== 0) {
            if( obj.layers_settings === undefined ){
                if ( obj.layers.length > 0 ) {
                    const droneLayer = new DroneLayer.initByUid(obj.layers[0]);
                    plan.droneLayersArray.push(droneLayer);
                }
            }else{
                if(obj.layers_settings.length > 0){
                    if(obj.layers_settings[0].is_hidden !== true){
                        const droneLayer = new DroneLayer.initByUid(obj.layers[0]);
                        plan.droneLayersArray.push(droneLayer);
                    }
                }
            }
        }
        return plan
    }

    setUserOwnerName(username){
        this.userName = username
        return this
    }

    planLatLng() {
        if ( this.markerCoord !== null ) {
            return this.markerCoord;
        }
        return null;
    }

    planArea() {
        if ( window.google === undefined || this.shapesArray.length === 0 ) {
            return null;
        }
        
        const latLngArray = this.shapesArray[0].coordsArray.map((coord) => {
            return new window.google.maps.LatLng({lat: coord.lat, lng: coord.lng});
        });
        const sqrMeter = window.google.maps.geometry.spherical.computeArea(latLngArray);
    
        const rawRai = sqrMeter/1600.00;
        const rai = Math.floor(rawRai);
        
        const rawNgan = (sqrMeter - (rai * 1600.0)) / 400.0;
        const ngan = Math.floor(rawNgan);
        
        const rawWa = (sqrMeter - ( (rai * 1600.0) + (ngan * 400.0) )) / 4.0;
        const wa = Math.floor(rawWa);
        
        return {
            sqrMeter: sqrMeter,
            rai: rai,
            ngan: ngan,
            wa: wa
        };
    }

    planAreaString() {
        const area = this.planArea();
        if ( area === null ) {
            return null;
        }
        const { rai, ngan, wa } = area;
        var textArray = [];
        if ( rai > 0 ) {
            const text = '' + rai + ' ไร่';
            textArray.push(text);
        }
        if ( ngan >0 ) {
            const text = '' + ngan + ' งาน';
            textArray.push(text);
        }
        if  ( wa > 0 ) {
            const text = '' + wa + ' ตร.วา';
            textArray.push(text);
        }
        return textArray.join(' ');
    }
    
    planBounds() {
        if ( window.google === undefined ) return null;
        var bounds = new window.google.maps.LatLngBounds();
        this.shapesArray.forEach((shape) => {
            shape.coordsArray.forEach((coord) => {
                bounds.extend(coord);
            });
        });
        if( this.markerCoord !== null && this.markerCoord !== ''){
            bounds.extend(this.markerCoord);
        }
        return bounds;
    }

    createdAtString() {
        if ( this.createdAt === null ) return null;
        return moment(this.createdAt).locale('th').format('D MMMM YYYY');
    }

    updatedAtString() {
        if ( this.updatedAt === null ) return null;
        return moment(this.updatedAt).locale('th').format('D MMMM YYYY');
    }

    hasAnyGeneralDetails() {
        return ( this.address !== '' ) || ( this.deed !== '' ) || ( this._description !== '' );
    }

}

export default Plan;


// WEBPACK FOOTER //
// ./src/Models/Plan.js